// extracted by mini-css-extract-plugin
export var infoItem = "_no-2";
export var title = "_no-0";
export var value = "_no-1";